"use client"

import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { storeRef } from "@/components/providers/StoreProvider"
import { useTERouter } from "@/hooks/app/useTERouter"
import { bookingActions } from "@/lib/redux/features/booking/reduce"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { getQueryStringSearchHotel } from "@/utils/hotel/getQueryStringSearchHotel"
import { getQueryStringSearchFlight } from "@/utils/string/getQueryStringSearchFlight"
import Image from "next/image"
import { Button, Modal, Row } from "antd"
import { usePathname } from "next/navigation"
import { forwardRef, useImperativeHandle } from "react"
import { useTranslation } from "react-i18next"

type ModalTimeOutProps = {}

export type ModalTimeOutRef = {
  close: () => void,
  open: () => void,
}

const ModalTimeOut = forwardRef<ModalTimeOutRef, ModalTimeOutProps>((props, ref) => {
  const showModalTimeout = useAppSelector(state => state.booking.showModalTimeOut)
  const router = useTERouter()
  const dispatch = useAppDispatch()
  const pathname = usePathname()
  const { t } = useTranslation()

  const isBookingHotel = pathname.includes('/booking/hotel')
  const isBookingTour = pathname.includes('/booking/tour')
  const isBookingEsim = pathname.includes('/booking/esim')

  const handleClose = () => {
    dispatch(bookingActions.setModalTimeOut(false))
  }

  const handleOpen = () => {
    dispatch(bookingActions.setModalTimeOut(true))
  }

  useImperativeHandle(ref, () => {
    return {
      close: handleClose,
      open: handleOpen
    }
  }, [])

  return (
    <Modal
      open={showModalTimeout}
      onCancel={handleClose}
      mask={{ closable: false }}
      closeIcon={false}
      footer={null}
    >
      <Row justify='center' align='middle' style={{ padding: '2rem 0' }}>
        <Image
          src='/static/stopwatch-timeout.svg'
          alt=''
          width={128}
          height={161}
          priority
        />
      </Row>
      <Row justify='center' align='middle'>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '1rem' }}>
          {t("booking.timeout_payment_title")}
        </Title>
      </Row>
      <Row justify='center' align='middle'>
        <Text style={{ textAlign: 'center', marginBottom: '1rem' }}>
          {isBookingHotel
            ? t("booking.timeout_payment_desc_hotel")
            : isBookingTour
              ? t("booking.timeout_payment_desc_tour")
              : isBookingEsim
                ? t("booking.timeout_payment_desc_esim")
                : t("booking.timeout_payment_desc_flight")}
        </Text>
      </Row>
      <Row justify='center' align='middle' style={{ padding: '1rem 0' }}>
        <Button
          type='primary'
          size='large'
          onClick={() => {
            if (isBookingHotel) {
              const newSearchString = `?${getQueryStringSearchHotel()}`
              router.push(`/hotels/result${newSearchString}`)
            } else if (isBookingTour) {
              const tourDetail = storeRef.current?.getState().tour.tour_details.data
              router.push(`/tours/category/${tourDetail?.categoryId}?start_date=`)
            } else if (isBookingEsim) {
              router.push("/esim-du-lich")
            } else {
              const newSearchString = `?${getQueryStringSearchFlight()}`
              router.push(`/flights/result${newSearchString}`)
            }

          }}
        >
          {isBookingEsim
            ? t("booking.timeout_payment_button_esim")
            : t("booking.timeout_payment_button")}
        </Button>
      </Row>
    </Modal>
  )
})

export default ModalTimeOut